import { render, staticRenderFns } from "./CategorySelectField.vue?vue&type=template&id=4dbb605b&"
import script from "./CategorySelectField.vue?vue&type=script&lang=js&"
export * from "./CategorySelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dbb605b')) {
      api.createRecord('4dbb605b', component.options)
    } else {
      api.reload('4dbb605b', component.options)
    }
    module.hot.accept("./CategorySelectField.vue?vue&type=template&id=4dbb605b&", function () {
      api.rerender('4dbb605b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/CategorySelectField.vue"
export default component.exports